import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { Spinner } from 'spinner';
import useV2Query from 'utils/useV2Query';
import { GET_LEDGER_OPTIONS_DATA } from './queries';

export const LedgerOptionsDataContext = React.createContext();
export const LedgerOptionsDataConsumer = LedgerOptionsDataContext.Consumer;

const LedgerOptionsDataProvider = ({ clientId, children }) => {
  const { data, loading } = useV2Query(GET_LEDGER_OPTIONS_DATA, {
    variables: { clientId },
  });

  if (loading) {
    return (
      <Grid container alignItems="center" justifyContent="center">
        <Spinner />
      </Grid>
    );
  }

  return (
    <LedgerOptionsDataContext.Provider value={data}>{children}</LedgerOptionsDataContext.Provider>
  );
};

LedgerOptionsDataProvider.propTypes = {
  clientId: PropTypes.number.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default LedgerOptionsDataProvider;
